function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#E6213C;}\r\n\t.st1{clip-path:url(#SVGID_2_);fill:#E6213C;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M65.4,151.8h74.1l28.7,28.7c1.5,1.5,3.5,2.3,5.5,2.3c1,0,2-0.2,3-0.6c2.9-1.2,4.8-4,4.8-7.1v-23.2h18 c12.8,0,23.2-10.4,23.2-23.2V66.7c0-12.8-10.4-23.2-23.2-23.2H65.4c-12.8,0-23.2,10.4-23.2,23.2v61.9 C42.2,141.4,52.6,151.8,65.4,151.8L65.4,151.8z M80.8,74.4H184c4.3,0,7.7,3.5,7.7,7.7c0,4.3-3.5,7.7-7.7,7.7H80.8 c-4.3,0-7.7-3.5-7.7-7.7C73.1,77.9,76.6,74.4,80.8,74.4L80.8,74.4z M80.8,105.4H184c4.3,0,7.7,3.5,7.7,7.7c0,4.3-3.5,7.7-7.7,7.7 H80.8c-4.3,0-7.7-3.5-7.7-7.7C73.1,108.8,76.6,105.4,80.8,105.4L80.8,105.4z M80.8,105.4"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  x: 42.2,
  y: 43.5,
  width: 264,
  height: 264
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M147.9,218.8h-8.5c-1-4.9-3-9.5-5.6-13.6l6-6c3-3,3-7.9,0-10.9c-3-3-7.9-3-10.9,0l-6,6 c-4.1-2.7-8.6-4.6-13.6-5.6v-8.5c0-4.3-3.5-7.7-7.7-7.7c-4.3,0-7.7,3.5-7.7,7.7v8.5c-4.9,1-9.5,3-13.6,5.6l-6-6c-3-3-7.9-3-10.9,0 c-3,3-3,7.9,0,10.9l6,6c-2.7,4.1-4.6,8.6-5.6,13.6h-8.5c-4.3,0-7.7,3.5-7.7,7.7c0,4.3,3.5,7.7,7.7,7.7h8.5c1,4.9,3,9.5,5.6,13.6 l-6,6c-3,3-3,7.9,0,10.9c1.5,1.5,3.5,2.3,5.5,2.3c2,0,4-0.8,5.5-2.3l6-6c4.1,2.7,8.6,4.6,13.6,5.6v8.5c0,4.3,3.5,7.7,7.7,7.7 c4.3,0,7.7-3.5,7.7-7.7v-8.5c4.9-1,9.5-3,13.6-5.6l6,6c1.5,1.5,3.5,2.3,5.5,2.3c2,0,4-0.8,5.5-2.3c3-3,3-7.9,0-10.9l-6-6 c2.7-4.1,4.6-8.6,5.6-13.6h8.5c4.3,0,7.7-3.5,7.7-7.7C155.6,222.3,152.1,218.8,147.9,218.8L147.9,218.8z M101.5,234.3 c-4.3,0-7.7-3.5-7.7-7.7s3.5-7.7,7.7-7.7s7.7,3.5,7.7,7.7S105.7,234.3,101.5,234.3L101.5,234.3z M101.5,234.3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M302.3,248.7l-6.3-3.7c0.3-2.4,0.5-4.8,0.5-7.2s-0.2-4.8-0.5-7.2l6.3-3.7c3.7-2.1,5-6.9,2.8-10.6l-15.5-26.8 c-2.1-3.7-6.9-5-10.6-2.8l-6.4,3.7c-3.9-2.9-8-5.3-12.4-7.2V176c0-4.3-3.5-7.7-7.7-7.7h-30.9c-4.3,0-7.7,3.5-7.7,7.7v7.3 c-4.4,1.9-8.5,4.3-12.4,7.2l-6.4-3.7c-3.7-2.1-8.4-0.9-10.6,2.8l-15.5,26.8c-2.1,3.7-0.9,8.4,2.8,10.6l6.3,3.7 c-0.3,2.4-0.5,4.8-0.5,7.2s0.1,4.8,0.5,7.2l-6.3,3.7c-3.7,2.1-5,6.9-2.8,10.6l15.5,26.8c2.1,3.7,6.9,5,10.6,2.8l6.4-3.7 c3.9,2.9,8,5.3,12.4,7.2v7.3c0,4.3,3.5,7.7,7.7,7.7h30.9c4.3,0,7.7-3.5,7.7-7.7v-7.3c4.4-1.9,8.5-4.3,12.4-7.2l6.4,3.7 c3.7,2.1,8.4,0.9,10.6-2.8l15.5-26.8C307.3,255.6,306,250.9,302.3,248.7L302.3,248.7z M237.1,261.1c-12.8,0-23.2-10.4-23.2-23.2 s10.4-23.2,23.2-23.2c12.8,0,23.2,10.4,23.2,23.2S249.9,261.1,237.1,261.1L237.1,261.1z M237.1,261.1"
});

function SvgServtechnique01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 350",
    style: {
      enableBackground: "new 0 0 350 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref5, _ref6)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServtechnique01);
export default __webpack_public_path__ + "static/media/serv technique-01.658809d3.svg";
export { ForwardRef as ReactComponent };